export const relationshipRevenueData = [
    {
        "company_name": "GARUDA TIMUR PACIFIC",
        "group_company": "GARUDAFOOD",
        "fee_income": 285914.285714,
        "total_income": 58505438.285714,
        "fy": 2025,
        "asset_nii": 40753666.8,
        "asset_nii_target": 63575720.21,
        "asset_nii_gap": 22822053.410000004,
        "percentage_asset_nii_target_achieved": 64.10256410054753,
        "liabilities_nii": 17465857.2,
        "liabilities_nii_target": 21483004.36,
        "liabilities_nii_gap": 4017147.16,
        "percentage_liabilities_nii_target_achieved": 81.30081299299238,
        "fee_income_target": 380266.0,
        "fee_income_gap": 94351.714286,
        "percentage_fee_income_target_achieved": 75.18796992473689,
        "tableData": {
            "2025": {
                "fee_income": 285914.285714,
                "total_income": 58505438.285714,
                "fy": 2025,
                "asset_nii": 40753666.8,
                "asset_nii_target": 63575720.21,
                "asset_nii_gap": 22822053.410000004,
                "percentage_asset_nii_target_achieved": 64.10256410054753,
                "liabilities_nii": 17465857.2,
                "liabilities_nii_target": 21483004.36,
                "liabilities_nii_gap": 4017147.16,
                "percentage_liabilities_nii_target_achieved": 81.30081299299238,
                "fee_income_target": 380266.0,
                "fee_income_gap": 94351.714286,
                "percentage_fee_income_target_achieved": 75.18796992473689
            },
            "2024": {
                "fee_income": 308787.42857112,
                "total_income": 63185873.34857112,
                "fy": 2024,
                "asset_nii": 44013960.144,
                "asset_nii_target": 68661777.8268,
                "asset_nii_gap": 24647817.682800006,
                "percentage_asset_nii_target_achieved": 64.10256410054753,
                "liabilities_nii": 18863125.776,
                "liabilities_nii_target": 23201644.7088,
                "liabilities_nii_gap": 4338518.9328000005,
                "percentage_liabilities_nii_target_achieved": 81.30081299299238,
                "fee_income_target": 410687.28,
                "fee_income_gap": 101899.85142888,
                "percentage_fee_income_target_achieved": 75.18796992473689
            },
            "2023": {
                "fee_income": 260181.99999974002,
                "total_income": 53239948.83999974,
                "fy": 2023,
                "asset_nii": 37085836.787999995,
                "asset_nii_target": 57853905.391100004,
                "asset_nii_gap": 20768068.603100006,
                "percentage_asset_nii_target_achieved": 64.10256410054753,
                "liabilities_nii": 15893930.052,
                "liabilities_nii_target": 19549533.9676,
                "liabilities_nii_gap": 3655603.9156000004,
                "percentage_liabilities_nii_target_achieved": 81.30081299299238,
                "fee_income_target": 346042.06,
                "fee_income_gap": 85860.06000026001,
                "percentage_fee_income_target_achieved": 75.18796992473689
            }
        }
    },
    {
        "company_name": "GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company": "GARUDAFOOD",
        "fee_income": 41725863.928571,
        "total_income": 27893903942.29286,
        "fy": 2025,
        "asset_nii": 19496524655.0,
        "asset_nii_target": 28269960750.0,
        "asset_nii_gap": 8773436095.0,
        "percentage_asset_nii_target_achieved": 68.96551724076943,
        "liabilities_nii": 8355653424.0,
        "liabilities_nii_target": 13034819341.0,
        "liabilities_nii_gap": 4679165917.0,
        "percentage_liabilities_nii_target_achieved": 64.10256410472793,
        "fee_income_target": 48819260.8,
        "fee_income_gap": 7093396.871428996,
        "percentage_fee_income_target_achieved": 85.47008546383194,
        "tableData": {
            "2025": {
                "fee_income": 41725863.928571,
                "total_income": 27893903942.29286,
                "fy": 2025,
                "asset_nii": 19496524655.0,
                "asset_nii_target": 28269960750.0,
                "asset_nii_gap": 8773436095.0,
                "percentage_asset_nii_target_achieved": 68.96551724076943,
                "liabilities_nii": 8355653424.0,
                "liabilities_nii_target": 13034819341.0,
                "liabilities_nii_gap": 4679165917.0,
                "percentage_liabilities_nii_target_achieved": 64.10256410472793,
                "fee_income_target": 48819260.8,
                "fee_income_gap": 7093396.871428996,
                "percentage_fee_income_target_achieved": 85.47008546383194
            },
            "2024": {
                "fee_income": 45063933.042856686,
                "total_income": 30125416257.67629,
                "fy": 2024,
                "asset_nii": 21056246627.4,
                "asset_nii_target": 30531557610.000004,
                "asset_nii_gap": 9475310982.6,
                "percentage_asset_nii_target_achieved": 68.96551724076943,
                "liabilities_nii": 9024105697.92,
                "liabilities_nii_target": 14077604888.28,
                "liabilities_nii_gap": 5053499190.360001,
                "percentage_liabilities_nii_target_achieved": 64.10256410472793,
                "fee_income_target": 52724801.664,
                "fee_income_gap": 7660868.621143317,
                "percentage_fee_income_target_achieved": 85.47008546383194
            },
            "2023": {
                "fee_income": 37970536.17499961,
                "total_income": 25383452587.486504,
                "fy": 2023,
                "asset_nii": 17741837436.05,
                "asset_nii_target": 25725664282.5,
                "asset_nii_gap": 7983826846.45,
                "percentage_asset_nii_target_achieved": 68.96551724076943,
                "liabilities_nii": 7603644615.84,
                "liabilities_nii_target": 11861685600.31,
                "liabilities_nii_gap": 4258040984.4700003,
                "percentage_liabilities_nii_target_achieved": 64.10256410472793,
                "fee_income_target": 44425527.328,
                "fee_income_gap": 6454991.153000386,
                "percentage_fee_income_target_achieved": 85.47008546383194
            }
        }
    },
    {
        "company_name": "PERTAMINA (PERSERO)",
        "group_company": "PERTAMINA GROUP",
        "fee_income": 16331098952.91429,
        "total_income": 16466021947.91429,
        "fy": 2025,
        "asset_nii": 94446096.5,
        "asset_nii_target": 113335315.8,
        "asset_nii_gap": 18889219.299999997,
        "percentage_asset_nii_target_achieved": 83.33333333333334,
        "liabilities_nii": 40476898.5,
        "liabilities_nii_target": 63143961.66,
        "liabilities_nii_gap": 22667063.159999996,
        "percentage_liabilities_nii_target_achieved": 64.1025641025641,
        "fee_income_target": 18290830827.0,
        "fee_income_gap": 1959731874.0857105,
        "percentage_fee_income_target_achieved": 89.285714287003,
        "tableData": {
            "2025": {
                "fee_income": 16331098952.91429,
                "total_income": 16466021947.91429,
                "fy": 2025,
                "asset_nii": 94446096.5,
                "asset_nii_target": 113335315.8,
                "asset_nii_gap": 18889219.299999997,
                "percentage_asset_nii_target_achieved": 83.33333333333334,
                "liabilities_nii": 40476898.5,
                "liabilities_nii_target": 63143961.66,
                "liabilities_nii_gap": 22667063.159999996,
                "percentage_liabilities_nii_target_achieved": 64.1025641025641,
                "fee_income_target": 18290830827.0,
                "fee_income_gap": 1959731874.0857105,
                "percentage_fee_income_target_achieved": 89.285714287003
            },
            "2024": {
                "fee_income": 17637586869.147434,
                "total_income": 17783303703.747433,
                "fy": 2024,
                "asset_nii": 102001784.22000001,
                "asset_nii_target": 122402141.06400001,
                "asset_nii_gap": 20400356.843999997,
                "percentage_asset_nii_target_achieved": 83.33333333333334,
                "liabilities_nii": 43715050.38,
                "liabilities_nii_target": 68195478.5928,
                "liabilities_nii_gap": 24480428.212799996,
                "percentage_liabilities_nii_target_achieved": 64.1025641025641,
                "fee_income_target": 19754097293.16,
                "fee_income_gap": 2116510424.0125675,
                "percentage_fee_income_target_achieved": 89.285714287003
            },
            "2023": {
                "fee_income": 14861300047.152004,
                "total_income": 14984079972.602003,
                "fy": 2023,
                "asset_nii": 85945947.815,
                "asset_nii_target": 103135137.378,
                "asset_nii_gap": 17189189.562999997,
                "percentage_asset_nii_target_achieved": 83.33333333333334,
                "liabilities_nii": 36833977.635,
                "liabilities_nii_target": 57461005.1106,
                "liabilities_nii_gap": 20627027.475599997,
                "percentage_liabilities_nii_target_achieved": 64.1025641025641,
                "fee_income_target": 16644656052.57,
                "fee_income_gap": 1783356005.4179966,
                "percentage_fee_income_target_achieved": 89.285714287003
            }
        }
    },
    {
        "company_name": "PERUSAHAAN LISTRIK NEGARA, PT (PERSERO)",
        "group_company": "PLN GROUP",
        "fee_income": 65546539.0,
        "total_income": 137176254.0,
        "fy": 2025,
        "asset_nii": 50140800.5,
        "asset_nii_target": 55656288.56,
        "asset_nii_gap": 5515488.060000002,
        "percentage_asset_nii_target_achieved": 90.09009008199665,
        "liabilities_nii": 21488914.5,
        "liabilities_nii_target": 27076032.27,
        "liabilities_nii_gap": 5587117.77,
        "percentage_liabilities_nii_target_achieved": 79.36507936507937,
        "fee_income_target": 79966777.58,
        "fee_income_gap": 14420238.579999998,
        "percentage_fee_income_target_achieved": 81.9672131147541,
        "tableData": {
            "2025": {
                "fee_income": 65546539.0,
                "total_income": 137176254.0,
                "fy": 2025,
                "asset_nii": 50140800.5,
                "asset_nii_target": 55656288.56,
                "asset_nii_gap": 5515488.060000002,
                "percentage_asset_nii_target_achieved": 90.09009008199665,
                "liabilities_nii": 21488914.5,
                "liabilities_nii_target": 27076032.27,
                "liabilities_nii_gap": 5587117.77,
                "percentage_liabilities_nii_target_achieved": 79.36507936507937,
                "fee_income_target": 79966777.58,
                "fee_income_gap": 14420238.579999998,
                "percentage_fee_income_target_achieved": 81.9672131147541
            },
            "2024": {
                "fee_income": 70790262.12,
                "total_income": 148150354.32000002,
                "fy": 2024,
                "asset_nii": 54152064.54000001,
                "asset_nii_target": 60108791.64480001,
                "asset_nii_gap": 5956727.104800003,
                "percentage_asset_nii_target_achieved": 90.09009008199665,
                "liabilities_nii": 23208027.66,
                "liabilities_nii_target": 29242114.851600002,
                "liabilities_nii_gap": 6034087.1916,
                "percentage_liabilities_nii_target_achieved": 79.36507936507937,
                "fee_income_target": 86364119.7864,
                "fee_income_gap": 15573857.666399999,
                "percentage_fee_income_target_achieved": 81.9672131147541
            },
            "2023": {
                "fee_income": 59647350.49,
                "total_income": 124830391.14,
                "fy": 2023,
                "asset_nii": 45628128.455,
                "asset_nii_target": 50647222.589600004,
                "asset_nii_gap": 5019094.134600002,
                "percentage_asset_nii_target_achieved": 90.09009008199665,
                "liabilities_nii": 19554912.195,
                "liabilities_nii_target": 24639189.3657,
                "liabilities_nii_gap": 5084277.1707,
                "percentage_liabilities_nii_target_achieved": 79.36507936507937,
                "fee_income_target": 72769767.5978,
                "fee_income_gap": 13122417.1078,
                "percentage_fee_income_target_achieved": 81.9672131147541
            }
        }
    },
    {
        "company_name": "PT SINARNIAGA SEJAHTERA",
        "group_company": "GARUDAFOOD",
        "fee_income": 338537887.857143,
        "total_income": 402909182.857143,
        "fy": 2025,
        "asset_nii": 45059906.5,
        "asset_nii_target": 79305435.44,
        "asset_nii_gap": 34245528.94,
        "percentage_asset_nii_target_achieved": 56.81818181818182,
        "liabilities_nii": 19311388.5,
        "liabilities_nii_target": 26263488.36,
        "liabilities_nii_gap": 6952099.859999999,
        "percentage_liabilities_nii_target_achieved": 73.52941176470588,
        "fee_income_target": 528119105.1,
        "fee_income_gap": 189581217.24285704,
        "percentage_fee_income_target_achieved": 64.10256409736218,
        "tableData": {
            "2025": {
                "fee_income": 338537887.857143,
                "total_income": 402909182.857143,
                "fy": 2025,
                "asset_nii": 45059906.5,
                "asset_nii_target": 79305435.44,
                "asset_nii_gap": 34245528.94,
                "percentage_asset_nii_target_achieved": 56.81818181818182,
                "liabilities_nii": 19311388.5,
                "liabilities_nii_target": 26263488.36,
                "liabilities_nii_gap": 6952099.859999999,
                "percentage_liabilities_nii_target_achieved": 73.52941176470588,
                "fee_income_target": 528119105.1,
                "fee_income_gap": 189581217.24285704,
                "percentage_fee_income_target_achieved": 64.10256409736218
            },
            "2024": {
                "fee_income": 365620918.8857145,
                "total_income": 435141917.48571444,
                "fy": 2024,
                "asset_nii": 48664699.02,
                "asset_nii_target": 85649870.27520001,
                "asset_nii_gap": 36985171.2552,
                "percentage_asset_nii_target_achieved": 56.81818181818182,
                "liabilities_nii": 20856299.580000002,
                "liabilities_nii_target": 28364567.4288,
                "liabilities_nii_gap": 7508267.8488,
                "percentage_liabilities_nii_target_achieved": 73.52941176470588,
                "fee_income_target": 570368633.508,
                "fee_income_gap": 204747714.6222856,
                "percentage_fee_income_target_achieved": 64.10256409736218
            },
            "2023": {
                "fee_income": 308069477.9500001,
                "total_income": 366647356.40000015,
                "fy": 2023,
                "asset_nii": 41004514.915,
                "asset_nii_target": 72167946.2504,
                "asset_nii_gap": 31163431.3354,
                "percentage_asset_nii_target_achieved": 56.81818181818182,
                "liabilities_nii": 17573363.535,
                "liabilities_nii_target": 23899774.4076,
                "liabilities_nii_gap": 6326410.872599999,
                "percentage_liabilities_nii_target_achieved": 73.52941176470588,
                "fee_income_target": 480588385.64100003,
                "fee_income_gap": 172518907.69099993,
                "percentage_fee_income_target_achieved": 64.10256409736218
            }
        }
    },
    {
        "company_name": "PUPUK INDONESIA PERSERO",
        "group_company": "PUPUK INDONESIA",
        "fee_income": 321628.571429,
        "total_income": 61061374.571429,
        "fy": 2025,
        "asset_nii": 42517822.2,
        "asset_nii_target": 69304050.19,
        "asset_nii_gap": 26786227.989999995,
        "percentage_asset_nii_target_achieved": 61.349693247992846,
        "liabilities_nii": 18221923.8,
        "liabilities_nii_target": 25328474.08,
        "liabilities_nii_gap": 7106550.2799999975,
        "percentage_liabilities_nii_target_achieved": 71.94244604884624,
        "fee_income_target": 414900.8571,
        "fee_income_gap": 93272.28567100002,
        "percentage_fee_income_target_achieved": 77.5193798530719,
        "tableData": {
            "2025": {
                "fee_income": 321628.571429,
                "total_income": 61061374.571429,
                "fy": 2025,
                "asset_nii": 42517822.2,
                "asset_nii_target": 69304050.19,
                "asset_nii_gap": 26786227.989999995,
                "percentage_asset_nii_target_achieved": 61.349693247992846,
                "liabilities_nii": 18221923.8,
                "liabilities_nii_target": 25328474.08,
                "liabilities_nii_gap": 7106550.2799999975,
                "percentage_liabilities_nii_target_achieved": 71.94244604884624,
                "fee_income_target": 414900.8571,
                "fee_income_gap": 93272.28567100002,
                "percentage_fee_income_target_achieved": 77.5193798530719
            },
            "2024": {
                "fee_income": 347358.85714332,
                "total_income": 65946284.53714333,
                "fy": 2024,
                "asset_nii": 45919247.976,
                "asset_nii_target": 74848374.2052,
                "asset_nii_gap": 28929126.229199994,
                "percentage_asset_nii_target_achieved": 61.349693247992846,
                "liabilities_nii": 19679677.704000004,
                "liabilities_nii_target": 27354752.0064,
                "liabilities_nii_gap": 7675074.302399998,
                "percentage_liabilities_nii_target_achieved": 71.94244604884624,
                "fee_income_target": 448092.92566800007,
                "fee_income_gap": 100734.06852468003,
                "percentage_fee_income_target_achieved": 77.5193798530719
            },
            "2023": {
                "fee_income": 292682.00000039,
                "total_income": 55565850.860000394,
                "fy": 2023,
                "asset_nii": 38691218.20200001,
                "asset_nii_target": 63066685.6729,
                "asset_nii_gap": 24375467.470899995,
                "percentage_asset_nii_target_achieved": 61.349693247992846,
                "liabilities_nii": 16581950.658000002,
                "liabilities_nii_target": 23048911.4128,
                "liabilities_nii_gap": 6466960.754799998,
                "percentage_liabilities_nii_target_achieved": 71.94244604884624,
                "fee_income_target": 377559.779961,
                "fee_income_gap": 84877.77996061002,
                "percentage_fee_income_target_achieved": 77.5193798530719
            }
        }
    },
    {
        "company_name": "SEMEN INDONESIA",
        "group_company": "SEMEN INDONESIA GROUP",
        "fee_income": 4238245609.292857,
        "total_income": 77953921460.53572,
        "fy": 2025,
        "asset_nii": 51600973096.0,
        "asset_nii_target": 76369440182.0,
        "asset_nii_gap": 24768467086.0,
        "percentage_asset_nii_target_achieved": 67.56756756763835,
        "liabilities_nii": 22114702755.0,
        "liabilities_nii_target": 34498936298.0,
        "liabilities_nii_gap": 12384233543.0,
        "percentage_liabilities_nii_target_achieved": 64.10256410219249,
        "fee_income_target": 5721631573.0,
        "fee_income_gap": 1483385963.7071428,
        "percentage_fee_income_target_achieved": 74.07407406818812,
        "tableData": {
            "2025": {
                "fee_income": 4238245609.292857,
                "total_income": 77953921460.53572,
                "fy": 2025,
                "asset_nii": 51600973096.0,
                "asset_nii_target": 76369440182.0,
                "asset_nii_gap": 24768467086.0,
                "percentage_asset_nii_target_achieved": 67.56756756763835,
                "liabilities_nii": 22114702755.0,
                "liabilities_nii_target": 34498936298.0,
                "liabilities_nii_gap": 12384233543.0,
                "percentage_liabilities_nii_target_achieved": 64.10256410219249,
                "fee_income_target": 5721631573.0,
                "fee_income_gap": 1483385963.7071428,
                "percentage_fee_income_target_achieved": 74.07407406818812
            },
            "2024": {
                "fee_income": 4577305258.036286,
                "total_income": 84190235177.37859,
                "fy": 2024,
                "asset_nii": 55729050943.68,
                "asset_nii_target": 82478995396.56001,
                "asset_nii_gap": 26749944452.88,
                "percentage_asset_nii_target_achieved": 67.56756756763835,
                "liabilities_nii": 23883878975.4,
                "liabilities_nii_target": 37258851201.840004,
                "liabilities_nii_gap": 13374972226.44,
                "percentage_liabilities_nii_target_achieved": 64.10256410219249,
                "fee_income_target": 6179362098.84,
                "fee_income_gap": 1602056840.8037143,
                "percentage_fee_income_target_achieved": 74.07407406818812
            },
            "2023": {
                "fee_income": 3856803504.4565,
                "total_income": 70938068529.08751,
                "fy": 2023,
                "asset_nii": 46956885517.36,
                "asset_nii_target": 69496190565.62,
                "asset_nii_gap": 22539305048.260002,
                "percentage_asset_nii_target_achieved": 67.56756756763835,
                "liabilities_nii": 20124379507.05,
                "liabilities_nii_target": 31394032031.18,
                "liabilities_nii_gap": 11269652524.130001,
                "percentage_liabilities_nii_target_achieved": 64.10256410219249,
                "fee_income_target": 5206684731.43,
                "fee_income_gap": 1349881226.9735,
                "percentage_fee_income_target_achieved": 74.07407406818812
            }
        }
    },
    {
        "company_name": "TUDUNG PUTRA PUTRI JAYA",
        "group_company": "GARUDAFOOD",
        "fee_income": 288057.142857,
        "total_income": 46075598.142857,
        "fy": 2025,
        "asset_nii": 32051278.7,
        "asset_nii_target": 42948713.46,
        "asset_nii_gap": 10897434.760000002,
        "percentage_asset_nii_target_achieved": 74.62686566816663,
        "liabilities_nii": 13736262.3,
        "liabilities_nii_target": 16758240.01,
        "liabilities_nii_gap": 3021977.709999999,
        "percentage_liabilities_nii_target_achieved": 81.96721309518948,
        "fee_income_target": 325504.5714,
        "fee_income_gap": 37447.428543000016,
        "percentage_fee_income_target_achieved": 88.49557522896282,
        "tableData": {
            "2025": {
                "fee_income": 288057.142857,
                "total_income": 46075598.142857,
                "fy": 2025,
                "asset_nii": 32051278.7,
                "asset_nii_target": 42948713.46,
                "asset_nii_gap": 10897434.760000002,
                "percentage_asset_nii_target_achieved": 74.62686566816663,
                "liabilities_nii": 13736262.3,
                "liabilities_nii_target": 16758240.01,
                "liabilities_nii_gap": 3021977.709999999,
                "percentage_liabilities_nii_target_achieved": 81.96721309518948,
                "fee_income_target": 325504.5714,
                "fee_income_gap": 37447.428543000016,
                "percentage_fee_income_target_achieved": 88.49557522896282
            },
            "2024": {
                "fee_income": 311101.71428556,
                "total_income": 49761645.99428556,
                "fy": 2024,
                "asset_nii": 34615380.996,
                "asset_nii_target": 46384610.536800005,
                "asset_nii_gap": 11769229.540800003,
                "percentage_asset_nii_target_achieved": 74.62686566816663,
                "liabilities_nii": 14835163.284000002,
                "liabilities_nii_target": 18098899.2108,
                "liabilities_nii_gap": 3263735.926799999,
                "percentage_liabilities_nii_target_achieved": 81.96721309518948,
                "fee_income_target": 351544.937112,
                "fee_income_gap": 40443.22282644002,
                "percentage_fee_income_target_achieved": 88.49557522896282
            },
            "2023": {
                "fee_income": 262131.99999987002,
                "total_income": 41928794.30999987,
                "fy": 2023,
                "asset_nii": 29166663.617,
                "asset_nii_target": 39083329.2486,
                "asset_nii_gap": 9916665.631600002,
                "percentage_asset_nii_target_achieved": 74.62686566816663,
                "liabilities_nii": 12499998.693000002,
                "liabilities_nii_target": 15249998.4091,
                "liabilities_nii_gap": 2749999.7160999994,
                "percentage_liabilities_nii_target_achieved": 81.96721309518948,
                "fee_income_target": 296209.159974,
                "fee_income_gap": 34077.159974130016,
                "percentage_fee_income_target_achieved": 88.49557522896282
            }
        }
    },
    {
        "company_name": "UNITED TRACTORS",
        "group_company": "ASTRA - UNITED TRACTORS",
        "fee_income": 99056143699.2857,
        "total_income": 103357948064.92142,
        "fy": 2025,
        "asset_nii": 3011263056.0,
        "asset_nii_target": 4787908259.0,
        "asset_nii_gap": 1776645203.0,
        "percentage_asset_nii_target_achieved": 62.89308176153172,
        "liabilities_nii": 1290541310.0,
        "liabilities_nii_target": 1497027919.0,
        "liabilities_nii_gap": 206486609.0,
        "percentage_liabilities_nii_target_achieved": 86.20689658627536,
        "fee_income_target": 145000000000.0,
        "fee_income_gap": 45943856300.714294,
        "percentage_fee_income_target_achieved": 68.31458186157636,
        "tableData": {
            "2025": {
                "fee_income": 99056143699.2857,
                "total_income": 103357948064.92142,
                "fy": 2025,
                "asset_nii": 3011263056.0,
                "asset_nii_target": 4787908259.0,
                "asset_nii_gap": 1776645203.0,
                "percentage_asset_nii_target_achieved": 62.89308176153172,
                "liabilities_nii": 1290541310.0,
                "liabilities_nii_target": 1497027919.0,
                "liabilities_nii_gap": 206486609.0,
                "percentage_liabilities_nii_target_achieved": 86.20689658627536,
                "fee_income_target": 145000000000.0,
                "fee_income_gap": 45943856300.714294,
                "percentage_fee_income_target_achieved": 68.31458186157636
            },
            "2024": {
                "fee_income": 106980635195.22858,
                "total_income": 111626583910.11514,
                "fy": 2024,
                "asset_nii": 3252164100.48,
                "asset_nii_target": 5170940919.72,
                "asset_nii_gap": 1918776819.24,
                "percentage_asset_nii_target_achieved": 62.89308176153172,
                "liabilities_nii": 1393784614.8000002,
                "liabilities_nii_target": 1616790152.5200002,
                "liabilities_nii_gap": 223005537.72000003,
                "percentage_liabilities_nii_target_achieved": 86.20689658627536,
                "fee_income_target": 156600000000.0,
                "fee_income_gap": 49619364804.77144,
                "percentage_fee_income_target_achieved": 68.31458186157636
            },
            "2023": {
                "fee_income": 90141090766.34999,
                "total_income": 94055732739.07849,
                "fy": 2023,
                "asset_nii": 2740249380.96,
                "asset_nii_target": 4356996515.690001,
                "asset_nii_gap": 1616747134.73,
                "percentage_asset_nii_target_achieved": 62.89308176153172,
                "liabilities_nii": 1174392592.1000001,
                "liabilities_nii_target": 1362295406.29,
                "liabilities_nii_gap": 187902814.19,
                "percentage_liabilities_nii_target_achieved": 86.20689658627536,
                "fee_income_target": 131950000000.0,
                "fee_income_gap": 41808909233.65001,
                "percentage_fee_income_target_achieved": 68.31458186157636
            }
        }
    }
]